import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from './core/Global';
import { UserService } from './core/user.service';

@Injectable()

export class EntityService {
	public url: string = Global.url_seguros

	private _userService: UserService = inject(UserService)
	private _http = inject(HttpClient)

	getAll(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'entities', { headers: headers })

	}

	save(office: any): Observable<any> {
		let params = office;
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		//Hacer peticion ajax
		var resultado = this._http.post(this.url + 'entities', params, { headers: headers })
		return resultado;
	}
	update(office: any): Observable<any> {
		let params = office

		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')

		var resultado = this._http.patch(this.url + 'entities/' + params._id, params, { headers: headers })
		return resultado;
	}

	getEntities() {
		return this._http.get(this.url + 'entities');
	}

	getEntitiesGroup(group: any) {
		return this._http.get(this.url + 'entities/get-group/' + group.id);
	}

	getAuditors() {
		return this._http.get(this.url + 'auditors');
	}

	getGroupsEntities() {
		return this._http.get(this.url + 'entities/get-groups');
	}

	getOffices() {
		return this._http.get(this.url + 'entities');
	}

	updateEntity(entity: any) {
		return this._http.patch(this.url + 'entities/' + entity._id, entity);
	}

	createEntity(entity: any) {
		return this._http.post(this.url + 'entities', entity);
	}

	updateGroup(group: any) {
		return this._http.patch(this.url + 'entities/update-group', group);
	}

	updateGroups(groups: any) {
		return this._http.patch(this.url + 'entities/update-groups', groups);
	}

	updateOffice(office: any) {
		return this._http.patch(this.url + 'entities/update-office', office);
	}



}
